export const WARNING_THRESHOLD = 80;
export const CRITICAL_THRESHOLD = 90;
export const isAboveWarning = value => Number(value) > WARNING_THRESHOLD;

export function metricSeverity(value) {
  if (Number(value) > CRITICAL_THRESHOLD) return "critical";
  return isAboveWarning(value) ? "warning" : "normal";
}
